export default __webpack_public_path__ + "static/media/ssc-chatbot.078a9c3e.png";